import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { debounceTime } from 'rxjs/operators';
import { EHealthService } from 'src/app/services/e-health.service';
import { PatientSearchResult, PatientService } from 'src/app/services/patient.service';
import { UserConfigService } from 'src/app/services/user-config.service';
import { DeleteConfirmDialogComponent } from '../delete-confirm-dialog/delete-confirm-dialog.component';

@Component({
  selector: 'app-e-health-messageviewer-dialog',
  templateUrl: './e-health-messageviewer-dialog.component.html',
  styleUrls: ['./e-health-messageviewer-dialog.component.scss']
})
export class EHealthMessageViewerDialogComponent implements OnInit {

  patientControl = new UntypedFormControl();
  searchReferingControl = new UntypedFormControl();
  patientProposition: PatientSearchResult[] = [];
  selectedDestination = 'protocol';

  constructor(public dialogRef: MatDialogRef<EHealthMessageViewerDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
              public dialog: MatDialog, public ehealth: EHealthService, public patient: PatientService,
              public userConfig: UserConfigService) { }

  ngOnInit(): void {
    this.patientControl.valueChanges.pipe(debounceTime(500)).subscribe(
      // Request ehealth for lastname
      value => {
        this.patientProposition.length = 0;
        if (value !== null && value.length > 3)
        {
          this.patient.search(value).subscribe(result => {
            this.patientProposition = result;
            console.log(this.patientProposition);
          });
        }
      }
    );
    this.searchReferingControl.valueChanges.subscribe(
      value => {
        this.patientControl.updateValueAndValidity({onlySelf: true, emitEvent: true});
      }
    );
  }
  onSelectPatient(event, content)
  {
    console.log(event);
    if (typeof(content.fields.patient.firstname) !== 'undefined' && typeof(content.fields.patient.lastname) !== 'undefined')
    {
      const searchPatient = content.fields.patient.firstname.trim() + ' ' + content.fields.patient.lastname.trim();
      this.patientControl.setValue(searchPatient, {emitEvent: true});
    }
  }

  displayPatient(patient?: PatientSearchResult): string | undefined {
    if (typeof(patient) === 'string')
    {
      return patient;
    }
    return patient ? patient.firstname + ' ' + patient.lastname : undefined;
  }

  getMessageTitle(message)
  {
    return (message.id === null) ? message.title : message.document.title;
  }

  startImport()
  {
    console.log('Import message ' + this.data.result.id);
    this.ehealth.retrievemessage(this.data.result.id);
  }

  deleteMessage()
  {
    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'delete')
      {
        console.log('delete message');
        this.ehealth.deletemessage(this.data.result.id);
      }
    });
  }
}
